export default __webpack_public_path__ + "static/media/partnert-merchant.30f1640e.svg";